module.exports = __webpack_public_path__ + "img/sso.66a87efb.png";